<template>
  <div class="home_page" ref="homePageRef">
    <!-- 顶部栏 -->
    <div
      class="top_area"
      :style="{
        paddingTop: `${$store.state.statusBarHeight}px`,
        height: `calc(0.46rem + ${$store.state.statusBarHeight}px)`,
        background: `rgba(255, 255, 255, ${scrollTop > 200 ? 1 : scrollTop / 200})`,
        borderBottom: `0.01rem solid rgba(239, 239, 239, ${scrollTop > 200 ? 1 : scrollTop / 200})`
      }"
    >
      <div class="top_area_inner">
        <div class="left_box">
          <img class="top_icon" src="@/assets/home/setting.png" alt="" @click="showSettingDrawer = true" />
          <img
            class="top_icon"
            src="@/assets/home/wallet.png"
            :style="{ marginInlineStart: '0.24rem' }"
            alt=""
            @click="showWalletDrawer = true"
          />
        </div>
        <div class="right_box">
          <img class="top_icon" src="@/assets/home/notification.png" alt="" @click="toMsg" />
          <div v-show="unreadMsgCount" class="dot">{{ unreadMsgCount }}</div>
        </div>
      </div>
    </div>
    <!-- 钱包余额卡片 -->
    <HomeWalletCard
      class="wallet_card"
      :has-withdraw-method="withdrawMethods && withdrawMethods.length > 0"
      :balance="balance"
      :balance-ready="balanceReady"
    />
    <!-- 转账入口 -->
    <!-- <div class="transfer_card" @click="toTransferPage">
      {{ $t('transfer.transfer') }}
      <img :class="$store.state.isMirroring && 'mirror'" class="jump_icon" src="@/assets/home/to_transfer.png" />
    </div> -->
    <!-- 交易记录卡片 -->
    <HomeTransactionList />
    <!-- 弹窗 -->
    <PopWindow
      :title="popTitle"
      :content="popContent"
      :btn="popBtn"
      :tips="popTips"
      :kycSuccessCase="kycSuccessCase"
      @getUnreadMsg="getUnreadMsg"
      @ifKYC="ifKYC"
      @readChangeNameNotice="readChangeNameNotice"
      @isEnterLastName="isEnterLastName"
      @closePop="popShow = false"
      v-show="popShow"
      class="pop_window"
    ></PopWindow>
    <PopWindow
      :msgImg="msgImg"
      :title="msgTitle"
      :content="msgContent"
      :btn="msgBtn"
      :cancelShow="cancelShow"
      :jumpLink="jumpLink"
      :messageId="messageId"
      @getUnreadMsg="getUnreadMsg"
      @ifKYC="ifKYC"
      @readChangeNameNotice="readChangeNameNotice"
      @isEnterLastName="isEnterLastName"
      @closePop="msgShow = false"
      v-show="msgShow"
      class="pop_window"
    ></PopWindow>
    <PopWindow v-show="needChangeName" :btn="needChangeNameConfirm" :content="changeNameContent"></PopWindow>
    <HomeSettingDrawer
      v-model="showSettingDrawer"
      :cur-language="curLanguage"
      :show-quick-login="quickLoginAuthList && quickLoginAuthList.length > 0"
      :hasPaymentCode="hasPaymentCode"
      @openLanguagePopup="openLanguagePopup"
      @openQuickLoginPopup="openQuickLoginPopup"
      @openAccountVerifyPopup="openAccountVerifyPopup"
      @openPasswordSetPopup="openPasswordSetPopup"
      @openPaymentCodeSetPopup="openPaymentCodeSetPopup"
      @logout="logout"
    />
    <HomeWalletDrawer
      v-model="showWalletDrawer"
      :level="level"
      :has-withdraw-method="withdrawMethods && withdrawMethods.length > 0"
    />
    <LanguagePopup
      :show="showLanguagePopup"
      @closePopup="closeLanguagePopup"
      @changeLanguage="onChangeLanguage"
    ></LanguagePopup>
    <HomeQuickLoginPopup
      v-model="showQuickLoginPopup"
      :quickLoginAuthList="quickLoginAuthList"
      @cancelQuickLogin="cancelQuickLogin"
    />
    <!-- 修改账号信息：先验证再修改/绑定 -->
    <!-- 邮箱/手机号验证 -->
    <AccountVerifyPopup
      v-model="showAccountVerifyPopup"
      :is-change-email="editAccountType === 'email'"
      @closePopup="showAccountVerifyPopup = false"
      @openAccountEditPopup="onOpenAccountEditPopup"
    />
    <!-- 绑定/修改-邮箱/手机号 -->
    <AccountEditPopup
      v-model="showAccountEditPopup"
      :is-change-email="editAccountType === 'email'"
      :api-params="accountEditInfo"
      :edit-type="accountEditType"
      @closePopup="onCloseAccountEditPopup"
    />
    <PasswordSetPopup v-model="showPasswordSetPopup" />
    <PaymentCodeSetPopup
      v-model="showPaymentCodeSetPopup"
      :hasOldPaymentCode="hasPaymentCode"
      @success="hasPaymentCode = true"
    />
  </div>
</template>

<script>
import Vue from 'vue'
import Vant, { Dialog, Toast } from 'vant'
import PopWindow from '@/components/PopWindow.vue'
import LanguagePopup from '@/components/LanguagePopup.vue'
import HomeSettingDrawer from '@/components/Home/HomeSettingDrawer.vue'
import HomeWalletCard from '@/components/Home/HomeWalletCard.vue'
import HomeTransactionList from '@/components/Home/HomeTransactionList.vue'
import HomeWalletDrawer from '@/components/Home/HomeWalletDrawer.vue'
import HomeQuickLoginPopup from '@/components/Home/HomeQuickLoginPopup.vue'
import AccountVerifyPopup from '@/components/Account/VerifyPopup.vue'
import AccountEditPopup from '@/components/Account/EditPopup.vue'
import PasswordSetPopup from '@/components/Password/PasswordSetPopup.vue'
import PaymentCodeSetPopup from '@/components/PaymentCode/PaymentCodeSetPopup.vue'
import { postReportLog } from '../utils/log'
import { clearSyncedLastName, readSyncedLastName } from '@/utils'

Vue.use(Vant)
Vue.use(Toast)
export default {
  name: 'Home',
  components: {
    PopWindow,
    LanguagePopup,
    HomeSettingDrawer,
    HomeWalletCard,
    HomeTransactionList,
    HomeWalletDrawer,
    HomeQuickLoginPopup,
    AccountVerifyPopup,
    AccountEditPopup,
    PasswordSetPopup,
    PaymentCodeSetPopup
  },
  data() {
    return {
      level: 0,
      showSettingDrawer: false,
      showWalletDrawer: false,
      showPasswordSetPopup: false,
      showPaymentCodeSetPopup: false,
      hasPaymentCode: false,
      curLanguage: '',
      quickLoginAuthList: [],
      showQuickLoginPopup: false,
      needChangeName: false,
      needChangeNameConfirm: '',
      changeNameContent: this.$t('home.invalidBasicLevelDialog'),
      balance: undefined,
      balanceReady: false,
      withdrawMethods: [],
      popShow: false,
      popContent: '',
      popTitle: '',
      popBtn: '',
      popTips: '',
      msgShow: false,
      msgContent: '',
      msgTitle: '',
      msgBtn: '',
      cancelShow: false,
      unreadMsgCount: 0,
      msgImg: '',
      jumpLink: '',
      messageId: '',
      count: 0,
      kycData: '',
      userId: this.$store.state.userInfo ? this.$store.state.userInfo.userId : '',
      kycSuccessCase: null,
      showLanguagePopup: false,
      showAccountVerifyPopup: false,
      editAccountType: 'email', // 邮箱或者手机号
      accountEditType: 'bind', // 绑定或者修改
      showAccountEditPopup: false,
      accountEditInfo: {
        // 邮箱
        oldEmail: '',
        // 手机号
        oldPhone: '',
        areaCode: '',
        code: ''
      },
      scrollTop: 0
    }
  },
  created() {
    if (sessionStorage.getItem('isToCheckUserInfo')) {
      sessionStorage.removeItem('isToCheckUserInfo')
      this.$router.push({
        name: 'CheckUserInfo'
      })
      return
    }
    this.getBalanceInfo()
    this.getValidWithdrawMethods()
  },
  mounted() {
    // 登录成功钱包授权免登录重定向
    const quickLoginAuthInfo = this.$store.state.quickLoginAuthInfo
    // 存储了有值，说明是从授权页面跳转的登录，则触发跳转登录成功之后的重定向
    if (quickLoginAuthInfo && quickLoginAuthInfo.hasOwnProperty('appId')) {
      this.$router.push({
        name: 'QuickLoginAuth',
        query: { ...quickLoginAuthInfo, hasLogined: 1 }
      })
      return
    }
    if (this.$store.state.userInfo) {
      this.level = this.$store.state.userInfo.level
    }
    this.curLanguage = localStorage.getItem('language') || 'en'
    this.getQuickLoginAuthList()
    this.$refs.homePageRef.addEventListener('scroll', this.handleScroll)
  },
  activated() {
    // 曝光埋点
    postReportLog({
      log_id: '440',
      extra: {
        page: 'home'
      }
    })
    const quickLoginAuthInfo = this.$store.state.quickLoginAuthInfo
    // 存储了有值，说明是从授权页面跳转的登录，则触发跳转登录成功之后的重定向
    if (quickLoginAuthInfo && quickLoginAuthInfo.hasOwnProperty('appId')) {
      this.$router.push({
        name: 'QuickLoginAuth',
        query: { ...quickLoginAuthInfo, hasLogined: 1 }
      })
      return
    }
    this.getBalanceInfo()
    this.getValidWithdrawMethods()
    this.getUserInfo()
    this.scrollTop = 0
    this.hasPayPassword().then((res) => {
      if (res) {
        // 支付密码存在
        this.hasPaymentCode = true
      } else {
        // 未设置支付密码
        this.hasPaymentCode = false
      }
    })
    if (this.$store.state.userInfo.userId) {
      this.getUnreadMsg()
    }
    if (this.$store.state.userInfo.level >= 1 && !this.$store.state.userInfo.email) {
      this.getUserEmailStatus()
    }
    if (this.$store.state.userInfo.level < 2) {
      this.getClaimKYCStatus()
    }
  },
  deactivated() {
    this.popShow = false
  },
  beforeDestroy() {
    this.$refs.homePageRef.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll() {
      this.scrollTop = this.$refs.homePageRef.scrollTop
    },
    // 已读公告
    readChangeNameNotice() {
      this.$http
        .get(window.serverPath + '/api/user/system/isRead?userId=' + this.$store.state.userInfo.userId)
        .then((res) => {
          if (res.data.code === '200') {
            this.popShow = false
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    getUserInfo() {
      const $this = this
      this.$http
        .get(window.serverPath + '/api/user/info')
        .then((res) => {
          if (res.data.code === '200') {
            let firstName = res.data.data.firstName
            let lastName = res.data.data.lastName
            let middleName = res.data.data.middleName
            let level = res.data.data.level
            this.level = res.data.data.level
            let countryNo = res.data.data.countryNo
            if (lastName) {
              clearSyncedLastName(res.data.data.userId)
            } else {
              const syncedLastName = readSyncedLastName(res.data.data.userId)
              if (syncedLastName) lastName = syncedLastName
            }
            if (firstName || lastName || middleName) {
              const regex = /^[a-zA-Z]+$/
              if (
                (firstName ? !regex.test(firstName) : '') ||
                (lastName ? !regex.test(lastName) : '') ||
                (middleName ? !regex.test(middleName) : '')
              ) {
                this.needChangeName = true
                this.needChangeNameConfirm = this.$t('common.confirm')
              }
            }
            this.userId = res.data.data.userId
            $this.$store.commit('setUserInfo', {
              ...res.data.data,
              lastName
            })
            if (level > 0 && countryNo !== 91 && !lastName) {
              this.isEnterLastName()
            } else if (this.userId) {
              this.ifKYC()
            } else if (!this.kycData || this.kycData.caseAudit !== 2) {
              this.getMsgPop()
            }
          }
        })
        .catch((err) => {
          console.log('异常', err)
        })
    },
    isEnterLastName() {
      this.popTitle = ''
      this.popContent = this.$t('home.lackLastNameDialog')
      this.popTips = ''
      this.popBtn = this.$t('home.fillIn')
      this.popShow = true
    },
    toMsg() {
      this.$router.push({ name: 'Message' })
    },
    // 未读消息数量
    getUnreadMsg() {
      this.$http
        .post(window.serverPath + '/api/user/system/message/unread_count', {})
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.unreadMsgCount = res.data.data
          }
        })
        .catch((err) => console.log(err))
    },
    getMsgPop() {
      let data = {
        userId: this.userId,
        page: 0,
        pageSize: 10
      }
      this.$http
        .post(window.serverPath + '/api/user/system/message/list', data)
        .then((res) => {
          if (res.data && res.data.code === '200') {
            const popMessage = res.data.data.find((item) => item.isFrame === 1)
            if (popMessage) {
              this.msgShow = true
              this.msgTitle = popMessage.title
              this.msgContent = popMessage.content
              this.msgImg = popMessage.picUrl
              this.msgBtn = popMessage.jumpLink ? this.$t('home.viewDetails') : 'OK'
              this.cancelShow = !!popMessage.jumpLink
              this.jumpLink = popMessage.jumpLink
              this.messageId = popMessage.messageId
            }
          }
        })
        .catch((err) => console.log(err))
    },
    ifKYC() {
      this.messageId = ''
      if (!this.$store.state.userInfo.userId) {
        return
      }
      this.$http
        .get(window.serverPath + '/api/user/kyc/getDetail?userId=' + this.$store.state.userInfo.userId)
        .then((res) => {
          if (res.data.code === '200') {
            let data = res.data.data
            this.kycData = data
            // 弹窗content有值 && (审核未通过 || 用户未读取) 4-审核通过，用户已读取
            if (data && data.content && data.caseAudit !== 4) {
              //  0-索取中
              if (data.caseAudit === 0) {
                this.popTitle = data.title
                this.popContent = data.content
                // 1-审核中
              } else if (data.caseAudit === 1) {
                this.popTitle = this.$t('home.docReviewingDialogTitle')
                this.popContent = this.$t('home.docReviewingDialogContent')
                // 2-审核通过，用户未读取
              } else if (data.caseAudit === 2) {
                this.popTitle = ''
                this.popContent = this.$t('home.docPassedDialog')
                // 3-审核不通过
              } else if (data.caseAudit === 3) {
                this.popTitle = ''
                this.popContent = this.$t('home.docUnqualifiedDialog')
              }
              // 1-强制索取
              if (data.isInput) {
                this.popShow = true
                if (data.caseAudit === 0) {
                  this.popBtn = this.$t('home.goToSubmit')
                  this.popTips = this.$t('home.uncompletedDialog')
                } else if (data.caseAudit === 3) {
                  this.popBtn = this.$t('home.goToSubmit')
                  this.popTips = this.$t('home.useMetWalletNormallyAfterPassed')
                } else {
                  this.popBtn = ''
                  if (data.caseAudit === 1) {
                    this.popTips = this.$t('home.useMetWalletNormallyAfterPassed')
                  }
                }
              } else {
                if (data.caseAudit === 2) {
                  this.kycSuccessCase = 2
                  this.popShow = true
                  this.popBtn = 'OK'
                  this.popTips = ''
                }
              }
            }
            this.getMsgPop()
          }
        })
        .catch((err) => console.log(err))
    },
    getClaimKYCStatus() {
      this.$http
        .get(window.serverPath + '/api/user/kyc/info?userId=' + this.$store.state.userInfo.userId)
        .then((res) => {
          if (res.data.code === '200' && res.data.data === 1) {
            const middleName = this.$store.state.userInfo.middleName
            let messageMsg = ''
            if (!middleName) {
              messageMsg = this.$t('home.requireSemiVerifiedDialog', [
                '' + this.$store.state.userInfo.firstName + ' ' + this.$store.state.userInfo.lastName
              ])
            } else {
              messageMsg = this.$t('home.requireSemiVerifiedDialog', [
                '' +
                  this.$store.state.userInfo.firstName +
                  ' ' +
                  this.$store.state.userInfo.middleName +
                  ' ' +
                  this.$store.state.userInfo.lastName
              ])
            }
            Dialog.confirm({
              title: this.$t('common.attention'),
              message: messageMsg,
              cancelButtonText: this.$t('common.cancel'),
              confirmButtonText: this.$t('home.goToVerify')
            })
              .then(() => {
                this.confirm()
              })
              .catch(() => {})
          }
        })
        .catch((err) => console.log(err))
    },
    // 判断是否有支付密码
    hasPayPassword() {
      return new Promise((resolve, reject) => {
        this.$http
          .get(window.serverPath + '/api/auth/hasPayPassword')
          .then((res) => {
            if (res.data && res.data.code === '200') {
              if (res.data.data) {
                resolve(true)
              } else {
                // 未设置支付密码
                resolve(false)
              }
            }
            // 接口返回异常
            reject('Request failed!')
          })
          .catch((err) => reject(err))
      })
    },
    confirm() {
      this.$router.push({ name: 'SemiVerified' })
    },
    getUserEmailStatus() {
      const middleName = this.$store.state.userInfo.middleName
      let messageMsg = ''
      if (!middleName) {
        messageMsg = this.$t('home.emailInvalidDialog', [
          '' + this.$store.state.userInfo.firstName + ' ' + this.$store.state.userInfo.lastName
        ])
      } else {
        messageMsg = this.$t('home.emailInvalidDialog', [
          '' +
            this.$store.state.userInfo.firstName +
            ' ' +
            this.$store.state.userInfo.middleName +
            ' ' +
            this.$store.state.userInfo.lastName
        ])
      }
      Dialog.confirm({
        title: this.$t('common.attention'),
        message: messageMsg,
        cancelButtonText: this.$t('home.later'),
        confirmButtonText: this.$t('home.goToVerify')
      }).then(() => {
        this.emailConfirm()
      })
    },
    emailConfirm() {
      this.editAccountType = 'email'
      this.showAccountVerifyPopup = true
    },
    // toTransferPage() {
    //   this.$router.push({ name: 'Transfer' })
    // },
    // 获取用户余额
    getBalanceInfo() {
      const $this = this
      this.$http
        .get(window.serverPath + '/api/balance/info')
        .then((res) => {
          const data = res.data
          if (data && data.code === '200') {
            $this.balance = data.data.balance
            $this.$store.commit('setBalance', data.data.balance)
          }
          $this.balanceReady = true
        })
        .catch((err) => {
          console.log(err)
          $this.balanceReady = true
        })
    },
    // 获取可用的提现方式
    getValidWithdrawMethods() {
      this.$http
        .get(window.serverPath + '/api/account/withdrawMethods', {
          cache: true,
          expire: 2000
        })
        .then((res) => {
          if (res.data && res.data.code === '200') {
            this.withdrawMethods = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    openLanguagePopup() {
      this.showLanguagePopup = true
    },
    closeLanguagePopup() {
      this.showLanguagePopup = false
    },
    onChangeLanguage(languageNo) {
      this.curLanguage = languageNo
    },
    openAccountVerifyPopup(props) {
      this.showAccountVerifyPopup = true
      this.editAccountType = props.isEmail ? 'email' : 'phone'
    },
    onOpenAccountEditPopup(props) {
      console.log('props', props)
      this.showAccountEditPopup = true
      this.accountEditType = props.editType
      this.accountEditInfo = props.apiParams
    },
    onCloseAccountEditPopup() {
      this.showAccountVerifyPopup = false
      this.showAccountEditPopup = false
    },
    logout() {
      Dialog.confirm({
        title: this.$t('common.attention'),
        message: this.$t('loginAndRegister.logoutDialog'),
        cancelButtonText: this.$t('common.cancel'),
        confirmButtonText: this.$t('common.confirm')
      })
        .then(() => {
          const $this = this
          this.$http
            .post(window.serverPath + '/api/auth/logout')
            .then((_res) => {
              $this.$router
                .push({
                  name: 'beforeLogin'
                })
                .then(() => {
                  $this.$store.commit('clearState')
                  localStorage.removeItem('token')
                  localStorage.removeItem('store')
                  this.$router.push('/before-login')
                  // localStorage.removeItem("to_logined")
                })
            })
            .catch((err) => console.log('退出失败', err))
        })
        .catch(() => {})
    },
    // 获取授权免登录列表
    getQuickLoginAuthList() {
      this.$http.post(window.serverPath + '/api/auth/getQuickLoginList', {}).then((res) => {
        if (res.data && res.data.code === '200') {
          this.quickLoginAuthList = res.data.data
        }
      })
    },
    openQuickLoginPopup() {
      this.showQuickLoginPopup = true
    },
    openPasswordSetPopup() {
      this.showPasswordSetPopup = true
    },
    openPaymentCodeSetPopup() {
      this.showPaymentCodeSetPopup = true
    },
    // 取消免登录授权
    cancelQuickLogin(merchantType) {
      let $this = this
      Dialog.confirm({
        title: '',
        message: this.$t('account.cancelQuickLogin'),
        cancelButtonText: this.$t('common.cancel'),
        confirmButtonText: this.$t('common.confirm')
      })
        .then(() => {
          $this.$http
            .post(window.serverPath + '/api/auth/cancelQuickLogin', { merchantType: merchantType })
            .then((res) => {
              if (res.data && res.data.code === '200') {
                this.getQuickLoginAuthList()
                this.showQuickLoginPopup = false
                // 刷新接口
                Toast({
                  message: this.$t('transactionDetail.cancelled')
                })
              } else {
                Toast({
                  message: res.data.message
                })
              }
            })
        })
        .catch(() => {})
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home_page {
  position: relative;
  width: 100%;
  height: 100%;
  background: linear-gradient(180deg, #D9FFE8 0.35%, #F5FFF9 52.27%);
  overflow-y: auto;
  scrollbar-width: none;
}

.home_page::-webkit-scrollbar {
  width: 0;
}

.top_area {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 0.46rem;
  padding: 0 0.16rem;
  background: transparent;
  box-sizing: border-box;
  z-index: 5;
}

.top_area_inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
}

@media screen and (min-width: 640px) {
  .top_area {
    width: 50vh;
    left: calc(50% - 25vh);
  }
}

.wallet_card {
  margin-top: 0.58rem !important;
}

.top_icon {
  width: 0.3rem;
  height: 0.3rem;
}

.transfer_card {
  width: calc(100% - 0.32rem);
  height: 0.5rem;
  margin: 0.2rem 0.16rem 0;
  padding: 0.12rem 0.2rem;
  box-sizing: border-box;
  border-radius: 0.16rem;
  background: #fbfffd;
  box-shadow: 0 0 0.1rem 0 rgba(63, 187, 112, 0.2);
  backdrop-filter: blur(0.05rem);
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #2f2f2f;
  font-family: 'PingFang SC';
  font-size: 0.14rem;
  font-style: normal;
  font-weight: 600;
}

.jump_icon {
  width: 0.1rem;
  height: 0.1rem;
  display: block;
}

.jump_icon.mirror {
  transform: rotateY(180deg);
}

.left_box,
.right_box {
  display: flex;
  align-items: center;
  position: relative;
}

.dot {
  min-height: 0.15rem;
  min-width: 0.15rem;
  border-radius: 50%;
  background: red;
  position: absolute;
  top: -0.05rem;
  right: 0;
  color: #fff;
  font-size: 0.1rem;
}

.dot.mirror {
  right: auto;
  left: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Home.vue